import { Select, Option } from './styles'
import { TreatmentTypeSelectProps as Props } from './type'
import { TreatmentTypeSelectHook } from './TreatmentTypeSelect.hook'

function TreatmentTypeSelect({ policyNumber, treatmentTypeId, disabled, onChange }: Props) {
  const { data, isLoading } = TreatmentTypeSelectHook({ policyNumber })

  const handleChange = (value: unknown) => {
    if (onChange) {
      onChange(value as string)
    }
  }

  return (
    <Select
      placeholder="เลือก"
      value={treatmentTypeId}
      disabled={disabled}
      onChange={handleChange}
      loading={isLoading}
    >
      {data?.map((o) => {
        return (
          <Option key={o.id} value={o.id}>
            {o.name}
          </Option>
        )
      })}
    </Select>
  )
}

export default TreatmentTypeSelect
